import { useTranslation } from 'react-i18next'

export const LanguageName = ({ code }: { code: string }) => {
  const { t } = useTranslation()
  return <>{t(`app.language.${code}`)}</>
}
